import { useCallback, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { usePatchingSuccessfully } from 'components/modules/Insurance/hooks/usePatchingSuccessfully';
import { usePreviousStepPathname } from 'components/modules/Insurance/hooks/usePreviousStepPathname';
import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';
import { getDrivers } from 'store/insurance/actions';
import { selectPageLoading } from 'store/insurance/selectors';
import { insAnketaAddDriver } from 'store/insuranceAnketa';
import * as InsuranceAnketaConstants from 'store/insuranceAnketa/constants';
import * as InsuranceAnketaSelectors from 'store/insuranceAnketa/selectors';
import { setBatchState } from 'store/insuranceCalculation';
import * as InsuranceCalculationConstants from 'store/insuranceCalculation/constants';
import * as InsuranceCalculationSelectors from 'store/insuranceCalculation/selectors';

import { useDisabledFields } from './hooks/useDisabledFields';
import { useSubmit } from './hooks/useSubmit';

const { ROUTES, ROUTE_NAMES } = Insurance;

export const useDriversPresenter = () => {
  const dispatch = useDispatch();

  const { pathname: previousPagePath } = usePreviousStepPathname();
  const { params } = useRouteMatch({ routes: ROUTES }) ?? {};
  const { id: worksheetId } = params ?? {};

  const drivers = useSelector(
    InsuranceAnketaSelectors.selectField(InsuranceAnketaConstants.FIELDS.DRIVERS)
  );
  const loading = useSelector(selectPageLoading(ROUTE_NAMES.DRIVERS));
  const multidrive = useSelector(
    InsuranceCalculationSelectors.selectField(InsuranceCalculationConstants.FIELDS.MULTIDRIVE)
  );
  const someDriverEdit = useSelector(InsuranceAnketaSelectors.selectSomeDriverEdit);

  const { disabled: pageRestrict } = useDisabledFields();
  const { onSubmit } = useSubmit({ drivers, multidrive });

  const onAddDriver = useCallback(() => {
    dispatch(insAnketaAddDriver());
  }, []);

  const onChangeMultidrive = useCallback((multidrive) => {
    dispatch(
      setBatchState({ [InsuranceCalculationConstants.FIELDS.MULTIDRIVE]: multidrive === 'true' })
    );
  }, []);

  useEffect(() => {
    dispatch(getDrivers(worksheetId));
  }, [worksheetId]);

  usePatchingSuccessfully();

  return {
    disabled: someDriverEdit || pageRestrict,
    drivers,
    loading,
    multidrive,
    onAddDriver,
    onChangeMultidrive,
    onSubmit,
    previousPagePath,
    someDriverEdit,
  };
};
